import {
    createStyles,
    Container,
    Title,
    Button,
    Group,
    Text,
  } from '@mantine/core';
  import { useNavigate } from 'react-router-dom';
  
  const useStyles = createStyles((theme) => ({
    inner: {
      display: 'flex',
      justifyContent: 'space-between',
      paddingTop: theme.spacing.xl * 4,
      paddingBottom: theme.spacing.xl * 4,
    },
  
    content: {
      [theme.fn.smallerThan('md')]: {
        maxWidth: '100%',
      },
    },
  
    title: {
      color: theme.colorScheme === 'dark' ? theme.white : theme.black,
      fontFamily: `Greycliff CF, ${theme.fontFamily}`,
      fontSize: 30,
      lineHeight: 1.2,
      fontWeight: 900,
  
      [theme.fn.smallerThan('xs')]: {
        fontSize: 28,
      },
    },
  
    control: {
      [theme.fn.smallerThan('xs')]: {
        flex: 1,
      },
    },
  
    image: {
      flex: 1,
  
      [theme.fn.smallerThan('md')]: {
        display: 'none',
      },
    },
  
    highlight: {
      position: 'relative',
      backgroundColor: theme.fn.variant({ variant: 'light', color: theme.primaryColor }).background,
      borderRadius: theme.radius.sm,
      padding: '4px 12px',
    },
  }));
  
  export default function About() {
    const { classes } = useStyles();
    const navigate = useNavigate();

    return (
      <div>
        <Container>
          <div className={classes.inner}>
            <div className={classes.content}>
              <Title className={classes.title} mt={-60}>
                <span className={classes.highlight}>About Us</span> 
              </Title>
              <Text mt="md" fz="xl" align='justify'>
                <b>Owl Environmental Inc.</b> is a hazardous waste and special hazards management firm servicing clients in Ontario for over 30 years.
              </Text>
              <Text mt="sm" fz="xl" align='justify'>
                With our transport, strategic alliances with respected waste firms and specialists - we can offer solutions to the management and disposal of your hazardous waste.
              </Text>
              <Text mt="sm" fz="xl" align='justify'>
                Owl Environmental Inc is committed to building trusted relationships with all our clients.
              </Text>
              <Group mt={30}>
                <Button radius="xl" size="md" className={classes.control} onClick={() => navigate('/contact',{})}>
                  Get a quote
                </Button>
              </Group>
            </div>
          </div>
        </Container>
      </div>
    );
  }